'use client';

import { RadioIndicator, type RadioIndicatorProps } from '../radio/radio/radio-indicator';
import {
  useRadioChoiceCardFrameContext,
  useRadioChoiceCardGroupContext,
} from './radio-choice-card-context';

export type RadioChoiceCardIndicatorProps = Pick<RadioIndicatorProps, 'className'>;

export const RadioChoiceCardIndicator = ({ className }: RadioChoiceCardIndicatorProps) => {
  const { checked, disabled } = useRadioChoiceCardFrameContext();
  const { error } = useRadioChoiceCardGroupContext();

  return (
    <RadioIndicator
      checked={checked}
      disabled={disabled}
      error={error}
      size="standard"
      className={className}
    />
  );
};
